"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/stable");
require("regenerator-runtime/runtime");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PublicNotFound = function PublicNotFound() {
  var iframeRef = (0, _react.useRef)(null);
  var setupListener = function setupListener() {
    iframeRef.current.contentDocument.addEventListener('click', function (e) {
      if (e.target.href) {
        window.location = e.target.href;
      }
    });
  };
  (0, _react.useEffect)(function () {
    document.getElementById('appcenter-not-found').addEventListener('load', setupListener);
    return function () {
      document.getElementById('appcenter-not-found').removeEventListener('load', setupListener);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("iframe", {
    id: "appcenter-not-found",
    title: "listing not found",
    src: "/404",
    sandbox: "allow-same-origin",
    ref: iframeRef
  });
};
var _default = exports.default = PublicNotFound;